import * as utils from './LocalStorageHelpers';

const localStorageLastLocationKey = 'metronic-lastLocation';

interface ILastLocation {
    pathname: string;
}

function acceptLocation(lastLocation: ILastLocation) {
    if (
        lastLocation &&
        lastLocation.pathname &&
        lastLocation.pathname !== '/' &&
        lastLocation.pathname.indexOf('auth') === -1 &&
        lastLocation.pathname !== '/logout'
    ) {
        return true;
    }

    return false;
}

export function saveLastLocation(lastLocation: ILastLocation) {
    if (acceptLocation(lastLocation)) {
        utils.setStorage(localStorageLastLocationKey, JSON.stringify(lastLocation), 120);
    }
}

export function forgotLastLocation() {
    utils.removeStorage(localStorageLastLocationKey);
}

export function getLastLocation() {
    const defaultLocation = { pathname: '/', title: 'Dashboard' };
    const localStorateLocations = utils.getStorage(localStorageLastLocationKey);

    if (!localStorateLocations) {
        return { pathname: '/', title: 'Dashboard' };
    }

    try {
        return JSON.parse(localStorateLocations);
    } catch {
        return defaultLocation;
    }
}

export function getCurrentUrl(location: ILastLocation) {
    return location.pathname.split(/[?#]/)[0];
}

export function checkIsActive(location: ILastLocation, url: string) {
    const current = getCurrentUrl(location);
    if (!current || !url) {
        return false;
    }

    if (current === url) {
        return true;
    }

    return false;
}
